export default {
  mediumText: "安全 快捷 巨省",
  bigText: "包網服務 行業首選",
  squareText1: "專業團隊",
  squareText2: "優質服務",
  squareText3: "技術突破",
  squareText4: "安全高效",
};
